import { ContactUpdateComponent } from './contact-update.component';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ContactInfoService } from '../../services/contact-info.service';
import { CityListService } from '../../../common/services/cityList.service';

@Component({
  selector: 'contact-update-mmdirect',
  templateUrl: './contact-update-mmdirect.component.html',
})
export class ContactUpdateMmDirectComponent extends ContactUpdateComponent {
  isZipLoading: boolean = false;
  constructor(protected contactUpdateService: ContactInfoService, protected formBuilder: FormBuilder) {
    super(contactUpdateService, formBuilder);
  }

  async zipCodeLookup(zip: string): Promise<void> {
    this.isZipLoading = true;
    const location = await this.contactUpdateService.getLocation(zip);

    if (!location) {
      this.contactFormGroup.get('zip').setErrors({ unsupportedZip: true });
      this.isZipLoading = false;
      return;
    }

    const cityListObj = new CityListService(CityListService.CHANNEL_MMDIRECT, location);
    this.cityList = cityListObj.getCityList();

    this.contactFormGroup.patchValue({
      city: cityListObj.getCity(),
      state: cityListObj.getStateCode(),
    });

    this.isZipLoading = false;
  }
}
